import ApiService from 'services/ApiService'

const microService = "check";
const assetController = "Asset";
const costTypeController = "CostType";
const eventTypeController = "EventType";
const eventController = "Event";
const optionsController = "Options";
const badRequestCode = 400;

export const FleetService = {
	/* EVENTS */
	createEvent(event) {
		return new Promise((resolve, reject) => {
			ApiService.post(`/${microService}/${eventController}`,event)
				.then(
					(result) => {
						resolve(result.data);
					},
					(error) => {
						reject(error);
					}
				);
		});
	},
	getEvent(id) {
		return new Promise((resolve, reject) => {
			ApiService.get(`/${microService}/${eventController}/${id}`, {}).then(
				(result) => {
					resolve(result.data)
				},
				(error) => {
					reject(error);
				});
		});
	},
	searchEvents(startDate, endDate, requestCount, pageNumber, searchTerm, softField, sortDirection, filters = []) {
		var searchRequest = createSearchRequest(requestCount, pageNumber, searchTerm, softField, sortDirection, filters);
		let requestUrl = `/${microService}/${eventController}/Search`;

		if (startDate && endDate) {
			requestUrl += `?startDate=${startDate}&endDate=${endDate}`;
		}

		return new Promise((resolve, reject) => {
			ApiService.post(requestUrl, searchRequest).then(
				(result) => {
					resolve(result.data);
				},
				(error) => {
					reject(error);
				});
		});
	},
	detailedEventSearch(eventIds) {
		let requestUrl = `/${microService}/${eventController}/DetailedSearch`;

		return new Promise((resolve, reject) => {
			ApiService.post(requestUrl, { eventIds }).then(
				(result) => {
					resolve(result.data);
				},
				(error) => {
					reject(error);
				});
		});
	},
	setScheduleDisabled(scheduleId, disabled) {
		return new Promise((resolve, reject) => {
			ApiService.patch(
				`/${microService}/${eventController}/Schedule/${scheduleId}`,
				{ disabled }
			).then(
				(result) => {
					resolve(result.data);
				},
				(error) => {
					if (error?.response?.status === badRequestCode) {
						reject(error.response.data);
					} else {
						reject("Unable to disable schedule, please try again.");
					}
				}
			);
		});
	},
	setScheduleOverrides(scheduleId, repeatFrequencyOverride, repeatIntervalOverride, repeatCountOverride, disabled, startDate) {
		const payload = {
			repeatFrequencyOverride,
			repeatIntervalOverride,
			repeatCountOverride,
			...(typeof disabled === "boolean" ? { disabled } : {}),
			...(startDate ? { startDate } : {})
		};
		return new Promise((resolve, reject) => {
			ApiService.patch(
				`/${microService}/${eventController}/Schedule/${scheduleId}`,
				payload
			).then(
				(result) => {
					resolve(result.data);
				},
				(error) => {
					reject(error);
				}
			);
		});
	},
	createEventSchedule(eventTypeId, assetId, startDate, repeatFrequencyOverride, repeatIntervalOverride, repeatCountOverride) {
		const payload = {
			eventTypeId,
			assetId,
			startDate,
			repeatFrequencyOverride,
			repeatIntervalOverride,
			repeatCountOverride
		};
		return new Promise((resolve, reject) => {
			ApiService.post(
				`/${microService}/EventSchedule`,
				payload
			).then(
				(result) => {
					resolve(result.data);
				},
				(error) => {
					reject(error);
				}
			);
		});
	},
	deleteEvent(eventId) {
		return new Promise((resolve, reject) => {
			ApiService.delete(`/${microService}/${eventController}/${eventId}`)
				.then(
					(result) => {
						resolve(result.data)
					},
					(error) => {
						reject(error);
					});
		});
	},
	getEventDocumentLink(eventId, documentId) {
		return new Promise((resolve, reject) => {
			ApiService.get(`/${microService}/${eventController}/${eventId}/Document/${documentId}`, {}).then(
				(result) => {
					resolve(result.data)
				},
				(error) => {
					reject(error);
				});
		});
	},
	reopenEvent(eventTypeId) {
		return new Promise((resolve, reject) => {
			ApiService.patch(`/${microService}/${eventController}/${eventTypeId}/Reopen`, {})
				.then(
					(result) => {
						resolve(result.data);
					},
					(error) => {
						reject(error);
					}
				);
		});
	},
	addEventDocument(eventId, document, eventDocumentationTypeId) {
        const config = {
            headers: {
                "content-Type": "multipart/form-data",
            },
        };

        const formData = new FormData();
        formData.append("document", document);
        formData.append("eventDocumentationTypeId", eventDocumentationTypeId);

		return new Promise((resolve, reject) => {
			ApiService.put(
				`/${microService}/${eventController}/${eventId}/Document`, 
				formData,
				config
			)
				.then(
				(response) => {
					resolve(response);
				},
				(error) => {
					reject(error);
				}
			);
		});
	},
	deleteEventDocument(eventId, documentId) {
		return new Promise((resolve, reject) => {
			ApiService.delete(`/${microService}/${eventController}/${eventId}/Document/${documentId}`)
				.then(
					(result) => {
						resolve(result.data)
					},
					(error) => {
						reject(error);
					});
		});
	},

	getFleetHubOverview(startDate, endDate, locationIds) {
		const payload = {
			startDate,
			endDate,
			locationIds
		};
		return new Promise((resolve, reject) => {
			ApiService.post(`/check/Event/huboverview`, payload)
				.then(
					(result) => resolve(result.data),
					(error) => reject(error)
				);
		});
	},

	/* ASSET */
	getEventTypesForAsset(id, includeAdhoc) {
		return new Promise((resolve, reject) => {
			ApiService.get(`/${microService}/${assetController}/${id}/EventTypes?includeAdhoc=${includeAdhoc}`, {}).then(
				(result) => {
					resolve(result.data)
				},
				(error) => {
					reject(error);
				});
		});
	},

	searchEventAssets(startDate, endDate, requestCount, pageNumber, searchTerm, softField, sortDirection, filters = []) {
		var searchRequest = createSearchRequest(requestCount, pageNumber, searchTerm, softField, sortDirection, filters);
		let requestUrl = `/${microService}/${assetController}/Search`;

		if (startDate && endDate) {
			requestUrl += `?startDate=${startDate}&endDate=${endDate}`;
		}

		return new Promise((resolve, reject) => {
			ApiService.post(requestUrl, searchRequest).then(
				(result) => {
					resolve(result.data);
				},
				(error) => {
					reject(error);
				});
		});
	},
	searchSchedules(requestCount, pageNumber, searchTerm, softField, sortDirection, filters = []) {
		var searchRequest = createSearchRequest(requestCount, pageNumber, searchTerm, softField, sortDirection, filters);
		let requestUrl = `/${microService}/${eventController}/Schedule/Search`;

		return new Promise((resolve, reject) => {
			ApiService.post(requestUrl, searchRequest).then(
				(result) => {
					resolve(result.data);
				},
				(error) => {
					if (error?.response?.status === badRequestCode) {
						reject(error.response.data);
					} else {
						reject("Could not fetch schedules, please try again.");
					}
				});
		});
	},
	searchAssetEvents(startDate, endDate, assetIds, filters = []) {
		const searchRequest = {
			startDate,
			endDate,
			assetIds,
			filters
		};
		let requestUrl = `/${microService}/${assetController}/Events`;

		return new Promise((resolve, reject) => {
			ApiService.post(requestUrl, searchRequest).then(
				(result) => {
					resolve(result.data);
				},
				(error) => {
					reject(error);
				}
			);
		});
	},

	getDisplayPreferences() {
		let requestUrl = `/${microService}/DisplayPreferences/Fleet`;
		return new Promise((resolve, reject) => {
			ApiService.get(requestUrl).then(
				(result) => {
					resolve(result.data);
				},
				(error) => {
					reject(error);
				});
		});
	},

	getHubDisplayPreferences() {
		let requestUrl = `/${microService}/DisplayPreferences/FleetHub`;
		return new Promise((resolve, reject) => {
			ApiService.get(requestUrl).then(
				(result) => {
					resolve(result.data);
				},
				(error) => {
					reject(error);
				});
		});
	},

	getAssetsWithEventWarnings(assetIds) {
		let requestUrl = `/${microService}/Asset/Warnings`;
		return new Promise((resolve, reject) => {
			ApiService.post(requestUrl, { assetIds }).then(
				(result) => {
					resolve(result.data);
				},
				(error) => {
					reject(error);
				});
		});
	},

	saveDisplayPreferences(preferences) {
		return new Promise((resolve, reject) => {
			ApiService.put(`/${microService}/DisplayPreferences/Fleet`, preferences).then(
				(response) => {
					resolve(response);
				},
				(error) => {
					if (error?.response?.status === badRequestCode) {
						reject(error.response.data);
					} else {
						reject("Unable to update Fleet preferences, please try again.");
					}
				}
			)
		});
	},

	saveHubDisplayPreferences(preferences) {
		return new Promise((resolve, reject) => {
			ApiService.put(`/${microService}/DisplayPreferences/FleetHub`, preferences).then(
				(response) => {
					resolve(response);
				},
				(error) => {
					if (error?.response?.status === badRequestCode) {
						reject(error.response.data);
					} else {
						reject("Unable to update Fleet Hub preferences, please try again.");
					}
				}
			)
		});
	},

	getAssetsWithWarnings(assetIds) {
		let requestUrl = `/${microService}/Asset/Warnings`;
		return new Promise((resolve, reject) => {
			ApiService.post(requestUrl, { assetIds }).then(
				(result) => {
					resolve(result.data);
				},
				(error) => {
					reject(error);
				});
		});
	},

	/* EVENT TYPES */
	getEventType(id) {
		return new Promise((resolve, reject) => {
			ApiService.get(`/${microService}/${eventTypeController}/${id}`, {}).then(
				(result) => {
					resolve(result.data)
				},
				(error) => {
					reject(error);
				});
		});
	},
	getEventTypesForAccount() {
		return new Promise((resolve, reject) => {
			ApiService.get(`/${microService}/${eventTypeController}/account`, {}).then(
				(result) => {
					resolve(result.data)
				},
				(error) => {
					reject(error);
				});
		});
	},
	createEventType(eventType) {
		return new Promise((resolve, reject) => {
			ApiService.post(`/${microService}/${eventTypeController}`, eventType).then( 
                (response) => {
			        resolve(response);
				},
                (error) => {
                    if (error?.response?.status === badRequestCode) {
						reject(error.response.data);
					} else {
						reject("Unable to create event type, please try again.");
					}
                }
            );
		});
	},
	updateEvent(eventId, updateRequest) {
		return new Promise((resolve, reject) => {
			ApiService.put(`/${microService}/${eventController}/${eventId}`, updateRequest).then(
				(response) => {
					resolve(response);
				},
				(error) => {
					if (error?.response?.status === badRequestCode) {
						reject(error.response.data);
					} else {
						reject("Unable to update event, please try again.");
					}
				}
			);
		});
	},
    updateEventType(eventTypeId, eventType) {
		return new Promise((resolve, reject) => {
			ApiService.put(`/${microService}/${eventTypeController}/${eventTypeId}`, eventType).then( 
                (response) => {
			        resolve(response);
				},
                (error) => {
                    if (error?.response?.status === badRequestCode) {
						reject(error.response.data);
					} else {
						reject("Unable to update event type, please try again.");
					}
                }
            );
		});
	},
	searchEventTypes(requestCount, pageNumber, searchTerm, sortField, sortDirection, filters = []) {
		var searchRequest = createSearchRequest(requestCount, pageNumber, searchTerm, sortField, sortDirection, filters);

		return new Promise((resolve, reject) => {
			ApiService.post(`/${microService}/${eventTypeController}/Search`, searchRequest).then(
				(result) => {
					resolve(result.data);
				},
				(error) => {
					reject(error);
				});
		});
	},
	deleteEventType(id) {
		return new Promise((resolve, reject) => {
			ApiService.delete(`/${microService}/${eventTypeController}/${id}`).then(
				(result) => {
					resolve(result.data)
				},
				(error) => {
					reject(error);
				});
		});
	},
	hideEventType(id, hidden) {
		return new Promise((resolve, reject) => {
			ApiService.patch(
				`/${microService}/${eventTypeController}/${id}/Hide`,
				{ hidden }
			).then(
				(result) => {
					resolve(result.data);
				},
				(error) => {
					reject(error);
				}
			);
		});
	},

	/* COST TYPES */
	getCosts(data) {
		return new Promise((resolve, reject) => {
			ApiService.post(`/${microService}/${costTypeController}/Search`, data).then(
				(result) => {
					resolve(result.data)
				},
				(error) => {
					reject(error);
				});
		});
	},
	deleteCost(id) {
		return new Promise((resolve, reject) => {
			ApiService.delete(`/${microService}/${costTypeController}/${id}`).then(
				(result) => {
					resolve(result.data)
				},
				(error) => {
					reject(error);
				});
		});
	},
    createCostType(costType) {
		return new Promise((resolve, reject) => {
			ApiService.post(`/${microService}/${costTypeController}`, costType).then( 
                (response) => {
			        resolve(response);
				},
                (error) => {
                    if (error.response.status === badRequestCode) {
						reject(error.response.data);
					} else {
						reject("Unable to create cost type, please try again.");
					}
                }
            );
		});
	},
    updateCostType(costTypeId, costType) {
		return new Promise((resolve, reject) => {
			ApiService.put(`/${microService}/${costTypeController}/${costTypeId}`, costType).then( 
                (response) => {
			        resolve(response);
				},
                (error) => {
                    if (error.response.status === badRequestCode) {
						reject(error.response.data);
					} else {
						reject("Unable to update cost type, please try again.");
					}
                }
            );
		});
	},

	/* SUPPLIERS */
    searchSuppliers(requestCount, pageNumber, searchTerm, softField, sortDirection) {
		var searchRequest = createSearchRequest(requestCount, pageNumber, searchTerm, softField, sortDirection, []);

        return new Promise((resolve, reject) => {
			ApiService.post(`/${microService}/${costTypeController}/Supplier/Search`, searchRequest).then(
				(result) => {
					resolve(result.data);
				},
				(error) => {
					reject(error);
				});
		});
    },
    updateSupplier(supplierId, supplier) {
		return new Promise((resolve, reject) => {
			ApiService.put(`/${microService}/${costTypeController}/${supplierId}/Supplier`, supplier).then( 
                (response) => {
			        resolve(response);
				},
                (error) => {
                    if (error.response.status === badRequestCode) {
						reject(error.response.data);
					} else {
						reject("Unable to update supplier, please try again.");
					}
                }
            );
		});
	},
    createSupplier(supplier) {
		return new Promise((resolve, reject) => {
			ApiService.post(`/${microService}/${costTypeController}/Supplier`, supplier).then( 
                (response) => {
			        resolve(response);
				},
                (error) => {
                    if (error.response.status === badRequestCode) {
						reject(error.response.data);
					} else {
						reject("Unable to create supplier, please try again.");
					}
                }
            );
		});
	},
    deleteSupplier(supplierId) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`/${microService}/${costTypeController}/Supplier/${supplierId}`).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                });
        });
    },

	/* Event Options */
	getEventOptions() {
		return new Promise((resolve, reject) => {
			ApiService.get(`/${microService}/${optionsController}/Event`, {}).then(
				(result) => {
					resolve(result.data)
				},
				(error) => {
					reject(error);
				});
		});
	},
	getEventTypeChangelog(eventTypeId, pageSize, pageNumber, startDate, endDate) {
		return new Promise((resolve, reject) => {
			ApiService.get(`/${microService}/${eventTypeController}/${eventTypeId}/changelog?resultCount=${pageSize}&pageNumber=${pageNumber}&startDate=${startDate}&endDate=${endDate}`).then(
				(result) => {
					resolve(result.data);
				},
				(error) => {
					reject(error);
				});
		});

	},

	/* Event Defect */
	createEventDefect(eventId, eventDefect) {
		return new Promise((resolve, reject) => {
			ApiService.post(`/${microService}/${eventController}/${eventId}/Defect`, eventDefect).then(
				(response) => {
					resolve(response);
				},
				(error) => {
					if (error.response.status === badRequestCode) {
						reject(error.response.data);
					} else {
						reject("Unable to create defect, please try again.");
					}
				}
			);
		});
	},
	updateEventDefect(eventId, eventDefect) {
		return new Promise((resolve, reject) => {
			ApiService.put(`/${microService}/${eventController}/${eventId}/Defect`, eventDefect).then(
				(response) => {
					resolve(response);
				},
				(error) => {
					if (error.response.status === badRequestCode) {
						reject(error.response.data);
					} else {
						reject("Unable to update defect, please try again.");
					}
				}
			);
		});
	},
	deleteEventDefect(eventId, eventDefectId) {
		return new Promise((resolve, reject) => {
			ApiService.delete(`/${microService}/${eventController}/${eventId}/Defect/${eventDefectId}`).then(
				(result) => {
					resolve(result.data);
				},
				(error) => {
					reject(error);
				});
		});
	},
	signOffDefect(eventId, defectId, defectSignOff) {
		return new Promise((resolve, reject) => {
			ApiService.patch(`/${microService}/${eventController}/${eventId}/defects/${defectId}/signoff`, defectSignOff).then(
				(response) => {
					resolve(response.data);
				},
				(error) => {
					if (error.response.status === badRequestCode) {
						reject(error.response.data);
					} else {
						reject("Unable to sign off defect, please try again.");
					}
				});
		});
	},
	signOffSyncTireDefect(defectId, defectSignOff) {
		return new Promise((resolve, reject) => {
			ApiService.patch(`/${microService}/${assetController}/tiretaskdefect/${defectId}/signoff`, defectSignOff)
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					if (error.response.status === badRequestCode) {
						reject(error.response.data);
					} else {
						reject("Unable to sign off defect, please try again.");
					}
				});
		});
	},
	/* Event Cost */
	createEventCost(eventId, eventCosts) {
		return new Promise((resolve, reject) => {
			ApiService.post(`/${microService}/${eventController}/${eventId}/Cost`, eventCosts).then(
				(response) => {
					resolve(response);
				},
				(error) => {
					if (error.response.status === badRequestCode) {
						reject(error.response.data);
					} else {
						reject("Unable to create cost, please try again.");
					}
				}
			);
		});
	},
	updateEventCost(eventId, eventCosts) {
		return new Promise((resolve, reject) => {
			ApiService.put(`/${microService}/${eventController}/${eventId}/Cost`, eventCosts).then(
				(response) => {
					resolve(response);
				},
				(error) => {
					if (error.response.status === badRequestCode) {
						reject(error.response.data);
					} else {
						reject("Unable to update cost, please try again.");
					}
				}
			);
		});
	},
	deleteEventCost(eventId, eventCostId) {
		return new Promise((resolve, reject) => {
			ApiService.delete(`/${microService}/${eventController}/${eventId}/Cost/${eventCostId}`).then(
				(result) => {
					resolve(result.data);
				},
				(error) => {
					reject(error);
				});
		});
	},
	getFleetReports(reportPageName) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/check/reports/fleet/${reportPageName}`).then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    requestAssetEventsReport(page, id, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/check/reports/${page}/${id}`, payload)
                .then(response => resolve(response.data))
                .catch(error => reject(error));
        });
	},
	searchEventCosts(requestCount, pageNumber, searchTerm, sortField, sortDirection, startDate, endDate, filters = []) {
		const searchRequest = {
			requestCount,
			pageNumber,
			searchTerm,
			sortField,
			sortDirection,
			filters
		};
		const requestUrl = `/check/Event/Costs?startDate=${startDate}&endDate=${endDate}`;
		return new Promise((resolve, reject) => {
			ApiService.post(requestUrl, searchRequest).then(
				(result) => {
					resolve(result.data);
				},
				(error) => {
					reject(error);
				}
			);
		});
	},
	searchAssetDefects(startDate, endDate, requestCount, pageNumber, searchTerm, softField, sortDirection, filters = []) {
		var searchRequest = createSearchRequest(requestCount, pageNumber, searchTerm, softField, sortDirection, filters);
		let requestUrl = `/${microService}/${assetController}/Defects`;

		if (startDate && endDate) {
			requestUrl += `?startDate=${startDate}&endDate=${endDate}`;
		}

		return new Promise((resolve, reject) => {
			ApiService.post(requestUrl, searchRequest).then(
				(result) => {
					resolve(result.data);
				},
				(error) => {
					reject(error);
				}
			);
		});
	}
};

function createSearchRequest(requestCount, pageNumber, searchTerm, softField, sortDirection, filters) {
    return {
        "requestCount": requestCount,
        "pageNumber": pageNumber,
        "searchTerm": searchTerm,
        "sortField": softField,
        "sortDirection": sortDirection,
        "filters": filters
    };
}